import { render, staticRenderFns } from "./ModalConfiguracaoUsuario.vue?vue&type=template&id=466a297a&scoped=true&"
import script from "./ModalConfiguracaoUsuario.vue?vue&type=script&lang=js&"
export * from "./ModalConfiguracaoUsuario.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfiguracaoUsuario.vue?vue&type=style&index=0&id=466a297a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466a297a",
  null
  
)

export default component.exports